import React from "react"
import { TrendingUp, TrendingDown, Minus } from "lucide-react"

export default function KpiCard({ label, value, suffix = "", delta, deltaLabel, sublabel }) {
  const isPositive = delta > 0
  const isNegative = delta < 0
  const isNeutral = delta === 0 || delta == null

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="text-[12px] font-medium text-slate-500">{label}</div>
      <div className="mt-1 flex items-baseline gap-1.5">
        <span className="text-[24px] font-semibold text-slate-900">
          {value ?? "—"}
        </span>
        {suffix && <span className="text-[14px] text-slate-500">{suffix}</span>}
      </div>
      {(delta != null || sublabel) && (
        <div className="mt-1 flex items-center gap-1 text-[12px]">
          {delta != null && (
            <>
              {isPositive && <TrendingUp className="h-3.5 w-3.5 text-emerald-600" />}
              {isNegative && <TrendingDown className="h-3.5 w-3.5 text-red-500" />}
              {isNeutral && <Minus className="h-3.5 w-3.5 text-slate-400" />}
              <span
                className={
                  isPositive ? "text-emerald-600" : isNegative ? "text-red-500" : "text-slate-400"
                }
              >
                {isNeutral ? "0%" : `${isPositive ? "+" : ""}${delta}%`}
              </span>
            </>
          )}
          {deltaLabel && <span className="text-slate-400">{deltaLabel}</span>}
          {sublabel && <span className="text-slate-400">{sublabel}</span>}
        </div>
      )}
    </div>
  )
}
